module.exports = __webpack_public_path__ + "static/media/br.057f3318.svg";